module.exports = __webpack_public_path__ + "static/img/bk.af59de2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freeSign/bk.webp
// module id = j0FY
// module chunks = 0